module.exports = __webpack_public_path__ + "img/people_black_24dp.13492667.svg";